import { logger } from './logger';

const STORAGE_VERSION = 'v1';

export const saveInStorage = <T>(persistingName: string, data: T): void => {
  try {
    localStorage.setItem(
      `${persistingName}_${STORAGE_VERSION}`,
      JSON.stringify(data),
    );
  } catch (error) {
    logger.error('Error saving item:', error);
  }
};

export const getFromStorage = <T>(
  persistingName: string,
  defaultValue: T,
): T => {
  try {
    const itemString = localStorage.getItem(
      `${persistingName}_${STORAGE_VERSION}`,
    );
    if (itemString) {
      return JSON.parse(itemString) as T;
    }
  } catch (error) {
    logger.error('Error loading item:', error);
  }

  return defaultValue;
};

export const removeFromStorage = (persistingName: string): void => {
  try {
    localStorage.removeItem(`${persistingName}_${STORAGE_VERSION}`);
  } catch (error) {
    logger.error('Error removing item:', error);
  }
};
